﻿import * as eventTypes from '../../../map/utils/eventTypes';
import Snap from 'ol/interaction/Snap';
import Modify from 'ol/interaction/Modify';
import Draw from 'ol/interaction/Draw';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import CircleStyle from 'ol/style/Circle.js';
import Icon from 'ol/style/Icon';
import LineString from 'ol/geom/LineString';
import { intersects as extentIntersects } from 'ol/extent';
import VectorSource from 'ol/source/Vector';
export default class SnapControl {
    constructor(resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.mapId = mapControl.mapId;
        this.controlId = 'js-modal-snap-tools-' + this.mapId + '-' + this.classId;
        this.endPointSnap = 'js-end-point-snap-' + this.mapId + '-' + this.classId;
        this.middlePointSnap = 'js-middle-point-snap-' + this.mapId + '-' + this.classId;
        this.intersectionPointSnap = 'js-intersection-snap-' + this.mapId + '-' + this.classId;
        this.degSnap = 'js-deg-snap-' + this.mapId + '-' + this.classId;
        this.vertexSnap = 'js-vertex-snap-' + this.mapId + '-' + this.classId;
        this.contourSnap = 'js-contour-snap-' + this.mapId + '-' + this.classId;
        this.edgeSnap = 'js-edge-snap-' + this.mapId + '-' + this.classId;
        this.snapOptions = 'js-snap-options-' + this.mapId + '-' + this.classId;
        this.snapUndoVertex = 'js-snap-undo-vertex-' + this.mapId + '-' + this.classId;
        this.snapFinishGeometry = 'js-snap-finish-geometry-' + this.mapId + '-' + this.classId;
        this.optionsControlId = 'js-modal-snap-options-' + this.mapId + '-' + this.classId;
        this.snapTolerance = 'js-snap-tolerance-' + this.mapId + '-' + this.classId;
        this.snapToleranceLabel = 'js-snap-tolerance-label-' + this.mapId + '-' + this.classId;
        this.optionsVisible = false;
        this.currentSnapTolerance = 7;
        this.mapMoveEndHandler = this._getMapMoveEndHandler();
        this.isSnapActive = false;
        this.justSnapped = false;
        this.pointStyle = new Style({
            image: new CircleStyle({
                radius: this.currentSnapTolerance - 2,
                fill: new Fill({ color: 'rgba(255,0,0,0.3)' }),
                stroke: new Stroke({ color: 'red', width: 1 })
            })
        });
        this.lastVertex = null;
        this.geomType = null;
        this.squareAngleSnap = null;
        this.endPointSnapSource = null;
        this.middlePointSnapSource = null;
        this.intersectionSnapSource = null;
        this.degSnapSource = null;
        this.edgeSnapSource = null;
        this.vertexSnapSource = null;
        this.isTimelineVisibile = false;
    }

    show() {
        if (!this.scaleBarBottom) {
            this.scaleBarBottom = $('.ol-scale-bar').css('bottom');
            this.scaleInputBottom = $('.scale-input').css('bottom');
            this.mapMouseBottom = $('.map-mouse-position').css('bottom');
            this.mapMapOverviewBottom = $('.ol-overviewmap').css('bottom');

            if ($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).length > 0) {
                this.crsWrapperBottom = $($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).children()[0]).css('bottom');
            }
        }

        $('#' + this.controlId).show();
        $('.ol-scale-bar').css('bottom', '5.85rem');
        $('.scale-input').css('bottom', '4.2rem');
        $('.map-mouse-position').css('bottom', '2.75rem');
        $('.ol-overviewmap').css('bottom', '7.85rem');

        if ($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).length > 0) {
            $($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).children()[0]).css('bottom', 'calc(' + this.crsWrapperBottom + ' + 2.75rem)');
        }

        this.map.getViewport().style.cursor = 'crosshair';
        this.isSnapActive = true;

        this.squareAngleSnap = new Snap({
            source: this.degSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: false,
            vertex: true,
            intersection: false
        });

        this.squareAngleSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this.mapControl.layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();
            const snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'squareAngle');
            layer.getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(this.squareAngleSnap);

        const middleSnap = new Snap({
            source: this.middlePointSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: false,
            vertex: true,
            intersection: false
        });

        middleSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this.mapControl.layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();
            const snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'middlePoint');
            layer.getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(middleSnap);

        const endpointSnap = new Snap({
            source: this.endPointSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: false,
            vertex: true,
            intersection: false
        });

        endpointSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this
                .mapControl
                .layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();

            const snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'endpoint');
            layer.getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(endpointSnap);

        let intersectionSnap = new Snap({
            source: this.intersectionSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: false,
            vertex: false,
            intersection: true
        });

        intersectionSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this
                .mapControl
                .layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();
            let snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'intersection');
            this.mapControl.layerHandler.getLayerById(layerTypes.SNAP)[0].getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(intersectionSnap);

        let edgeSnap = new Snap({
            source: this.edgeSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: true,
            vertex: false,
            intersection: false
        });

        edgeSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this
                .mapControl
                .layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();
            let snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'edge');

            this.mapControl.layerHandler.getLayerById(layerTypes.SNAP)[0].getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(edgeSnap);

        let vertexSnap = new Snap({
            source: this.vertexSnapSource,
            pixelTolerance: this.currentSnapTolerance,
            edge: false,
            vertex: true,
            intersection: false
        });

        vertexSnap.on('snap', evt => {
            this.justSnapped = true;
            const layer = this
                .mapControl
                .layerHandler
                .getLayerById(layerTypes.SNAP)[0];
            layer.getSource().clear();
            this._adjustSnapOrder();
            let snapFeature = new Feature(new Point(evt.vertex));
            snapFeature.set('snapType', 'vertex');

            this.mapControl.layerHandler.getLayerById(layerTypes.SNAP)[0].getSource().addFeature(snapFeature);
        });

        this.map.addInteraction(vertexSnap);

        this._adjustSnap();
    }

    hide() {
        $('#' + this.controlId).hide();
        $('#' + this.optionsControlId).hide();
        this.optionsVisible = false;
        this._clearSnap();
        $('.ol-scale-bar').css('bottom', this.scaleBarBottom);
        $('.scale-input').css('bottom', this.scaleInputBottom);
        $('.map-mouse-position').css('bottom', this.mapMouseBottom);
        $('.ol-overviewmap').css('bottom', this.mapMapOverviewBottom);

        if ($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).length > 0) {
            $($('#xpmap-crs-switcher-wrapper-' + this.mapId + '-' + this.classId).children()[0]).css('bottom', this.crsWrapperBottom);
        }

        this.map.getViewport().style.cursor = 'inherit';
        this.isSnapActive = false;
        this.lastVertex = null;

        const snapsToRemove = [];
        this.map.getInteractions().forEach((interaction) => {
            if (interaction instanceof Snap) {
                snapsToRemove.push(interaction);
            }
        });

        snapsToRemove.forEach((snapInteraction) => {
            this.map.removeInteraction(snapInteraction);
        });
    }

    init() {
        this.endPointSnapSource = new VectorSource();
        this.middlePointSnapSource = new VectorSource();
        this.intersectionSnapSource = new VectorSource();
        this.degSnapSource = new VectorSource();
        this.vertexSnapSource = new VectorSource();
        this.edgeSnapSource = new VectorSource();

        this.menuContainer.append(this._getTemplate());

        $('.snap-button').on('click', (evt) => {
            let id = evt.currentTarget.getAttribute('id');

            if (id == this.edgeSnap) {
                if ($('#' + this.edgeSnap).hasClass('selected')) {
                    $('.snap-button').removeClass('selected');
                } else {
                    $('.snap-button').addClass('selected');
                }
            } else {
                if ($('#' + id).hasClass('selected')) {
                    $('#' + id).removeClass('selected');
                } else {
                    $('#' + id).addClass('selected');
                    $('#' + this.edgeSnap).addClass('selected');
                }
            }

            this._adjustSnap();
        });

        $('#' + this.snapFinishGeometry).on('click', () => {
            $event.notify(eventTypes.FINISH_GEOMETRY, { geomType: this.geomType }, this, this.mapControl.classId);
        });

        $('#' + this.snapUndoVertex).on('click', () => {
            $event.notify(eventTypes.UNDO_VERTEX, {}, this, this.mapControl.classId);
        });

        $('#' + this.snapOptions).on('click', () => {
            if (!this.optionsVisible) {
                $('#' + this.optionsControlId).show();
                $('#' + this.snapOptions).addClass('selected');
                this.optionsVisible = true;
            } else {
                $('#' + this.optionsControlId).hide();
                $('#' + this.snapOptions).removeClass('selected');
                this.optionsVisible = false;
            }
        });

        $('#' + this.snapTolerance).on('change', () => {
            $('#' + this.snapToleranceLabel)[0].innerHTML = $('#' + this.snapTolerance).val();
            this.currentSnapTolerance = $('#' + this.snapTolerance).val();
            this._adjustSnap();
        });

        $event.register(eventTypes.START_SNAP, this._getStartSnapHandler(), this, this.mapControl.classId);
        $event.register(eventTypes.STOP_SNAP, this._getStopSnapHandler(), this, this.mapControl.classId);
        $event.register(eventTypes.MAP_MOVE_END, this.mapMoveEndHandler, this, this.mapControl.classId);
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getPointerMoveHandler(), this, this.mapControl.classId);
        $event.register(eventTypes.MAP_POINTER_CLICK, this._getVertexAddedHandler(), this, this.mapControl.classId);

        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.SNAP,
            geometryType: geomTypes.GEOM_POINT,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: '',
            ignoreStyle: true,
            addToLegend: false,
            showLegend: false,
            declutter: false
        }).then(() => {
            let layer = this.mapControl.layerHandler.getLayerById(layerTypes.SNAP)[0];
            layer.setStyle((feature) => {
                this.pointStyle.getImage().setRadius(this.currentSnapTolerance - 2);

                let snapUrl;
                let scale = 0.2;
                let displacement = [0, -1];

                switch (feature.get('snapType')) {
                    case 'edge': {
                        snapUrl = this.rootURL + 'img/symbologies/edge.svg';
                        displacement = [0, -1.1];
                        break;
                    }
                    case 'vertex': {
                        snapUrl = this.rootURL + 'img/symbologies/vertex.svg';
                        scale = 0.3;
                        break;
                    }
                    case 'intersection': {
                        snapUrl = this.rootURL + 'img/symbologies/intersection.svg';
                        scale = 0.5;
                        break;
                    }
                    case 'middlePoint': {
                        snapUrl = this.rootURL + 'img/symbologies/middle-point.svg';
                        scale = 0.5;
                        break;
                    }
                    case 'endpoint': {
                        snapUrl = this.rootURL + 'img/symbologies/end-point.svg';
                        scale = 0.5;
                        break;
                    }
                    case 'squareAngle': {
                        snapUrl = this.rootURL + 'img/symbologies/90deg.svg';
                        scale = 0.3;
                        break;
                    }
                    default: snapUrl = this.rootURL + 'img/symbologies/edge.svg';
                        break;
                }

                let snapIcon = new Style({
                    image: new Icon({
                        src: snapUrl,
                        anchor: displacement,
                        scale: scale
                    })
                });

                return [this.pointStyle, snapIcon];
            });
        });

        $('.snap-button').addClass('selected');
    }

    _getVertexAddedHandler() {
        var handler = (eventName, data, sender) => {
            if (this.isSnapActive && this.geomType != 'Point' && this.geomType != 'MultiPoint') {
                this.lastVertex = data.coordinate;

                if (!$('#' + this.contourSnap).hasClass('selected')) {
                    $event.notify(eventTypes.CONTOUR_SNAP_OFF, {}, this, this.mapControl.classId);
                }
            }
        };

        return handler;
    }

    _getTruePerpendiculars(P, feature) {
        const geom = feature.getGeometry();
        let rings = [];

        switch (geom.getType()) {
            case 'LineString':
                rings.push(geom.getCoordinates());
                break;
            case 'MultiLineString':
                rings = geom.getLineStrings().map(ls => ls.getCoordinates());
                break;
            case 'Polygon':
                rings.push(geom.getLinearRing(0).getCoordinates());
                break;
            case 'MultiPolygon':
                rings = geom.getPolygons().map(poly => poly.getLinearRing(0).getCoordinates());
                break;
        }

        const feet = [];

        rings.forEach(coords => {
            for (let i = 0; i < coords.length - 1; i++) {
                const A = coords[i], B = coords[i + 1];
                const ABx = B[0] - A[0], ABy = B[1] - A[1];
                const APx = P[0] - A[0], APy = P[1] - A[1];
                const ab2 = ABx * ABx + ABy * ABy;
                if (ab2 === 0) continue;
                const t = (ABx * APx + ABy * APy) / ab2;
                if (t > 0 && t < 1) {
                    feet.push([A[0] + t * ABx, A[1] + t * ABy]);
                }
            }
        });

        return feet;
    }

    _getMapMoveEndHandler() {
        return () => {
            if (this.isSnapActive) {
                this._adjustSnap();
            }
        };
    }

    _getBufferedExtent(coordinate, pixelTolerance) {
        const resolution = this.map.getView().getResolution();
        const mapTolerance = resolution * pixelTolerance;

        return [
            coordinate[0] - mapTolerance,
            coordinate[1] - mapTolerance,
            coordinate[0] + mapTolerance,
            coordinate[1] + mapTolerance
        ];
    }

    _simplifyGeoms(features, currentExtent) {
        let result = [];
        features.forEach(feature => {
            const geom = feature.getGeometry();
            const rings = this._getCoordinateRings(geom);

            rings.forEach(coords => {
                for (let i = 0; i < coords.length - 1; i++) {
                    const p1 = coords[i], p2 = coords[i + 1];
                    if (!Array.isArray(p1) || !Array.isArray(p2)) continue;

                    const segExt = [
                        Math.min(p1[0], p2[0]), Math.min(p1[1], p2[1]),
                        Math.max(p1[0], p2[0]), Math.max(p1[1], p2[1])
                    ];
                    if (extentIntersects(currentExtent, segExt)) {
                        const seg = new Feature(new LineString([p1, p2]));
                        result.push(seg);
                    }
                }
            });
        });

        return result;
    }

    _adjustSnap(event) {
        if (event == null || this.justSnapped) {
            return;
        }

        this._clearSnap();
        let currentExtent = this._getBufferedExtent(event.coordinate, this.currentSnapTolerance);
        let features = this.mapControl.selectionHandler.getVisibleFeaturesInExtent(currentExtent);

        const resolution = this.map.getView().getResolution();
        const radiusMu = resolution * this.currentSnapTolerance;

        features = features.filter(feature => {
            const pt = feature.getGeometry().getClosestPoint(event.coordinate);
            const dx = pt[0] - event.coordinate[0];
            const dy = pt[1] - event.coordinate[1];
            return Math.hypot(dx, dy) <= radiusMu;
        });

        if (features.length == 0 || features.length > 100) {
            return;
        }

        features = this._simplifyGeoms(features, currentExtent);

        if ($('#' + this.degSnap).hasClass('selected') && this.lastVertex != null) {
            features.forEach((feature) => {
                const points = this._getTruePerpendiculars(this.lastVertex, feature);
                if (points.length > 0) {
                    points.forEach(point => {
                        this.degSnapSource.addFeature(new Feature(new Point(point)));
                    });
                }
            });
        }

        if ($('#' + this.middlePointSnap).hasClass('selected')) {
            features.forEach(f => {
                const geom = f.getGeometry();
                const type = geom.getType();

                if (type === 'LineString') {
                    this.middlePointSnapSource.addFeature(new Feature(new Point(geom.getCoordinateAt(0.5))));
                } else if (type === 'MultiLineString') {
                    geom.getCoordinates().forEach(lineCoords => {
                        const midpoint = new LineString(lineCoords).getCoordinateAt(0.5);
                        this.middlePointSnapSource.addFeature(new Feature(new Point(midpoint)));
                    });

                } else if (type === 'Polygon') {
                    geom.getCoordinates().forEach(ringCoords => {
                        for (let i = 0; i < ringCoords.length - 1; i++) {
                            const [x0, y0] = ringCoords[i];
                            const [x1, y1] = ringCoords[i + 1];
                            this.middlePointSnapSource.addFeature(new Feature(new Point([
                                (x0 + x1) / 2,
                                (y0 + y1) / 2
                            ])));
                        }
                    });

                } else if (type === 'MultiPolygon') {
                    geom.getCoordinates().forEach(polygonCoords => {
                        polygonCoords.forEach(ringCoords => {
                            for (let i = 0; i < ringCoords.length - 1; i++) {
                                const [x0, y0] = ringCoords[i];
                                const [x1, y1] = ringCoords[i + 1];
                                this.middlePointSnapSource.addFeature(new Feature(new Point([
                                    (x0 + x1) / 2,
                                    (y0 + y1) / 2
                                ])));
                            }
                        });
                    });
                }
            });
        }

        if ($('#' + this.endPointSnap).hasClass('selected')) {
            features.forEach(f => {
                const geom = f.getGeometry();
                const type = geom.getType();

                if (type === 'LineString') {
                    const coords = geom.getCoordinates();
                    this.endPointSnapSource.addFeature(new Feature(new Point(coords[0])));
                    this.endPointSnapSource.addFeature(new Feature(new Point(coords[coords.length - 1])));
                } else if (type === 'MultiLineString') {
                    geom.getCoordinates().forEach(lineCoords => {
                        this.endPointSnapSource.addFeature(new Feature(new Point(lineCoords[0])));
                        this.endPointSnapSource.addFeature(new Feature(new Point(lineCoords[lineCoords.length - 1])));
                    });
                }
            });
        }

        if ($('#' + this.intersectionPointSnap).hasClass('selected')) {
            features.forEach(x => {
                this.intersectionSnapSource.addFeature(x.clone());
            });
        }

        if ($('#' + this.vertexSnap).hasClass('selected')) {
            features.forEach(x => {
                this.vertexSnapSource.addFeature(x.clone());
            });
        }

        if ($('#' + this.edgeSnap).hasClass('selected')) {
            features.forEach(x => {
                this.edgeSnapSource.addFeature(x.clone());
            });
        }
    }

    _getCoordinateRings(geom) {
        try {
            const type = geom.getType();
            const c = geom.getCoordinates();
            switch (type) {
                case 'Polygon':
                    return [c[0]];
                case 'MultiPolygon':
                    return c.map(polygonCoords => polygonCoords[0]);
                case 'LineString':
                    return [c];
                case 'MultiLineString':
                    return c;
                case 'GeometryCollection':
                    return geom.getGeometries()
                        .flatMap(g => this._getCoordinateRings(g));
                default:
                    return [];
            }
        } catch (err) {
            return [];
        }
    }

    _adjustSnapOrder() {
        const layer = this
            .mapControl
            .layerHandler
            .getLayerById(layerTypes.SNAP)[0];
        layer.setZIndex(this.mapControl.layerHandler.temporaryLayerIdx + 1);

        this.map.getInteractions().forEach(interaction => {
            if (interaction instanceof Draw || interaction instanceof Modify) {
                interaction.overlay_.setZIndex(this.mapControl.layerHandler.temporaryLayerIdx);
            }
        });
    }

    _getPointerMoveHandler() {
        var handler = (eventName, data, sender) => {
            if (!this.justSnapped) {
                this.mapControl.layerHandler.getLayerById(layerTypes.SNAP)[0].getSource().clear();
            }
            this.justSnapped = false;

            if (this.isSnapActive) {
                this._adjustSnap(data);
            }
        };

        return handler;
    }

    _getStartSnapHandler() {
        var handler = (eventName, data, sender) => {
            this.geomType = data.geomType;
            this.show();
        };

        return handler;
    }

    _getStopSnapHandler() {
        var handler = (eventName, data, sender) => {
            this.hide();
        };

        return handler;
    }

    _clearSnap() {
        this.endPointSnapSource.clear();
        this.middlePointSnapSource.clear();
        this.intersectionSnapSource.clear();
        this.degSnapSource.clear();
        this.edgeSnapSource.clear();
        this.vertexSnapSource.clear();
    }

    _getTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div id="` + this.controlId + `" class="snap-tools-bar" style="display: none;">
                            <div id="` + this.endPointSnap + `" class="snap-button icon-snap-end-point" style="margin-left: 0rem;"></div>
                            <div id="` + this.middlePointSnap + `" class="snap-button icon-snap-middle-point"></div>
                            <div id="` + this.intersectionPointSnap + `" class="snap-button icon-snap-intersection"></div>
                            <div id="` + this.degSnap + `" class="snap-button icon-snap-deg"></div>
                            <div id="` + this.vertexSnap + `" class="snap-button icon-snap-vertex"></div>
                            <div id="` + this.contourSnap + `" class="snap-button icon-snap-contour"></div>
                            <div id="` + this.edgeSnap + `" class="snap-button icon-snap-edge"></div>
                            <div id="` + this.snapOptions + `" class="snap-special-button fal fa-cog" style="margin-left: 1.6rem;"></div>
                            <div id="` + this.snapUndoVertex + `" class="snap-special-button fal fa-undo"></div>
                            <div id="` + this.snapFinishGeometry + `" class="snap-special-button fal fa-check"></div>
                            <div id=` + this.optionsControlId + ` class="snap-tools-options" style="display: none;">
                                <div class="snap-tolerance-slidecontainer">
                                  <input type="range" min="3" max="20" value="` + this.currentSnapTolerance + `" class="snap-tolerance-slider" id="` + this.snapTolerance + `">
                                  <label class="form-label">` + this.resourcesHandler.get('Tolerance') + `: <span id="` + this.snapToleranceLabel + `">` + this.currentSnapTolerance + `</span></label>
                                </div>
                            </div>
                         </div>`;
        return div.firstChild;
    }
}